import React, { useState, useEffect } from "react";
import { Modal, Row, Col, Table } from "antd";
import { useTranslation } from 'react-i18next'

const ModalDesingProcess = ({ visible, handleVisible, desing }) => {
  const handleOk = () => {
    handleVisible(false);
  };
  const { t } = useTranslation();

  const [datos,setDatos] = useState([]);
  const columns = [
    {
      title: t('table.header.name'),
      dataIndex: "name",
      key: "name",
      width: 200,
      render: (name,obj) => obj.name2 === "" ? t('phase.'+name) : (t('phase.'+name)+" "+obj.name2)
    },
    {
      title: t('table.header.value'),
      dataIndex: "value",
      key: "value",
      width: 200,
    }

  ];

  useEffect(() => {
    if(desing){
      let arrayComodin = []
      let i = 0;
      for(let dato in desing.forja){
        const datoFormado = {
          name: desing.forja[dato]["name"],
          name2: desing.forja[dato]["name2"],
          value: desing.forja[dato]["valor"]+desing.forja[dato]["suf"]
        }
        i=i++
        arrayComodin.push(datoFormado)
      }
      setDatos(arrayComodin)
    }
  }, [desing]);

  return (
    desing && (
      <div>
        <Modal
          title={(desing.desingName ? desing.desingName : t('text.text_no_linked') )}
          visible={visible}
          onOk={handleOk}
          onCancel={handleOk}
          width="60vw"
          footer={null}
          style={{top:"2vw"}}
        >
          <Row style={{marginBottom:"2%"}}>
            <Col span={24}>
              <Table
                bordered
                dataSource={datos}
                columns={columns}
                pagination={{ pageSize: 25 }}
                scroll={{ y: "34vw" }}
                bodyStyle={{ backgroundColor: "White" }}
              />
            </Col>
          </Row >
        </Modal>
      </div>
    )
  );
};

export default ModalDesingProcess;